import type { ImpressionType } from '@/ImpressionType'

export const impressionDataMarelle: ImpressionType = {
  title: 'Marelle',
  impressionContent: `
<p>
Souvenirs d'enfance,<br/>
Marque de différence,<br/>
Écho l'absence,<br/>
Terrible abstinence.<br/>
<br/>
</p>

<p>
Couleur pastel,<br/>
Des jeux, des marelles,<br/>
Que nous tracions à deux,<br/>
Inconscient d'être heureux.<br/>
<br/>
</p>

<p>
Recueil funèbre,<br/>
Tes yeux bleus, ne verront plus le ciel,<br/>
Je deviens gardien, sentinelle,<br/>
Survivant que la vie appelle.<br/>
<br/>
</p>

<p>
Je te cherche en moi.<br/>
Et te trouve, parfois,<br/>
Sous l'oraison d'une phrase, d'un rythme.<br/>
D'une pensée, d'un mythe,<br/>
D'une dispute, d'un cri,<br/>
Ou d'une sonnerie,<br/>
D'une lumière, ombrelle,<br/>
Partout, tout est "elle",<br/>
Comblé l'absence de croyance,<br/>
Et voir mes parents, sombrer, dans la souffrance.<br/>
<br/>
</p>

<p>
D'un trait qui s'est encré,<br/>
Maintenant légué,<br/>
A jamais,<br/>
Le souvenir de tes excès,<br/>
De tes rires,<br/>
De petite fille,<br/>
Jeune femme fragile,<br/>
Tu t'es arrêtée,<br/>
Tu l'avais décidé,<br/>
Têtu et borné,<br/>
Tu nous as laissés,<br/>
Nous qui ne pourrons,<br/>
Plus que te pleurer<br/>
<br/>
</p>
  `,
  illustrationCaption: "Souvenirs d'enfance",
  illustrationCopyright: 'Source: chatgpt',
  illustrationPath: '/img/impressions/marelle-1.jpg',
  noteEntries: ["Partout et nul part, de Paris à Angers, jusqu'au confain du lyonnais"]
}
